import { render, staticRenderFns } from "./clientServiceRelation.vue?vue&type=template&id=6b6a4a5c&scoped=true&"
import script from "./clientServiceRelation.vue?vue&type=script&lang=js&"
export * from "./clientServiceRelation.vue?vue&type=script&lang=js&"
import style0 from "./clientServiceRelation.vue?vue&type=style&index=0&id=6b6a4a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a4a5c",
  null
  
)

export default component.exports